import React, { useState } from 'react';

import MergeConfirmation from './merge_confirmation';
import MergeSelection from './merge_selection';
import PropertyMergeStep from 'components/properties/merge/property_merge_step';

import { associateListing, postMerge } from '../api';
import { MERGE } from './helpers';

interface Props {
  deal: Record<string, any>;
  listing: Record<string, any>;
  project: Record<string, any>;
  setModalSize: (size: string | null) => void;
  onClose: () => void;
  onConnect: (listing: Record<string, any>, researchProperty: Record<string, any>) => void;
}

export default function MergeProperties({ deal, listing, project, setModalSize, onClose, onConnect }: Props) {
  const [saving, setSaving] = useState(false);
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [properties, setProperties] = useState<Record<string, any>[]>([]);
  const [attributesMap, setAttributesMap] = useState<Record<string, number | null>>({});
  const projectProperty = project.edgeResearchProperty;

  const handleMergeSelection = async (selection: string) => {
    if (selection === MERGE) {
      setCurrentStepIndex(prev => prev + 1);
      setModalSize('xl');
    } else {
      setSaving(true);
      const updatedDeal = await associateListing(deal, listing, projectProperty.id);
      setSaving(false);
      onConnect(updatedDeal.listing, updatedDeal.researchProperty);
    }
  };

  const handlePropertyMergeMapping = async (
    properties: Record<string, any>[],
    attributesMap: Record<string, number | null>
  ) => {
    setProperties(properties);
    setAttributesMap(attributesMap);
    setCurrentStepIndex(prev => prev + 1);
    setModalSize(null);
  };

  const handlePropertyMerge = async () => {
    setSaving(true);
    const { id: newPropertyId } = await postMerge(properties, attributesMap);
    const updatedDeal = await associateListing(deal, listing, newPropertyId);
    setSaving(false);
    onConnect(updatedDeal.listing, updatedDeal.researchProperty);
  };

  const steps = [
    <MergeSelection
      dealPropertyName={deal.researchProperty.name}
      key="merge-selection"
      projectPropertyName={projectProperty.name}
      saving={saving}
      onClose={onClose}
      onComplete={handleMergeSelection}
    />,
    <PropertyMergeStep
      key="merge-properties"
      propertyIds={[deal.researchProperty.id, projectProperty.id]}
      saving={saving}
      onClose={onClose}
      onMerge={handlePropertyMergeMapping}
    />,
    <MergeConfirmation
      key="merge-confirmation"
      saving={saving}
      onClose={onClose}
      onConfirm={handlePropertyMerge}
    />
  ];

  return steps[currentStepIndex];
}
